import { useEffect, useState, Suspense } from 'react';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { Grid, Box, Container, Typography } from '@mui/material'
import { api_menu_list } from '../../states/selector'
import { BrowserRouter, Route, Switch, Link, NavLink, useParams, useRouteMatch, useLocation, Redirect } from 'react-router-dom';
import Items from '../../blocks/items'
import { CONFIG } from '../../states/settings'

const MenuList = (props)=>{
  let ul = useLocation()
  let [ menu_list, setMenuList ] = useRecoilState(api_menu_list)


  useEffect(()=>{
    setMenuList(menu_list)

  }, [])


  return (
    <Box className='wrapper' sx={{
      '@media (max-width: 900px)':{
        padding: 2
      },
      padding: 3
    }}>
    <Grid container spacing={2}>
    { 
      menu_list.map((v,i)=>{
        return (
          <Grid item sm={12} md={3} lg={3} xl={3} width='100%'>
            <Box className='Top_menu_name' sx={{
              '@media (max-width: 900px)':{
                marginTop: i != 0 ? '1.8rem' : 0
              }
            }}>
              <Link to={`${CONFIG.PAGE_ROOT_PATH}/${v.group_name}/`}>
                { v.group_name }
              </Link>
            </Box>
            
            <Items
              json_file={v.json_file}
              limit={8}
              menu_id={v.group_name}
              use_pager={false}
              use_grid={true}
              show_full={false}
              from_url={ul.pathname}
            />
          </Grid>
        )
      })
    }
    </Grid>
    </Box>
  )
}

export default MenuList;
